/**
 * FJ Product Card - Variant Swatches & Direct Add to Cart
 * Handles variant swatches, image swapping, and AJAX add-to-cart
 */

(function() {
  'use strict';

  // Handle variant swatch selection
  document.addEventListener('click', (e) => {
    const swatch = e.target.closest('.fj-swatch');
    if (!swatch || swatch.classList.contains('is-disabled')) return;

    const card = swatch.closest('.fj-card');
    if (!card) return;

    const swatchGroup = swatch.closest('.fj-swatch-group');
    swatchGroup.querySelectorAll('.fj-swatch').forEach(s => s.classList.remove('is-active'));
    swatch.classList.add('is-active');

    const variantImage = swatch.dataset.variantImage;
    if (variantImage) {
      const productImage = card.querySelector('.fj-card__img');
      if (productImage) { productImage.src = variantImage; }
    }

    const variantId = swatch.dataset.variantId;
    const form = card.querySelector('.fj-card__add-to-cart-form');
    if (form && variantId) {
      const variantInput = form.querySelector('input[name="id"]');
      if (variantInput) { variantInput.value = variantId; }
    }

    const quickViewBtn = card.querySelector('.fj-quick-view-trigger');
    if (quickViewBtn && variantId) { quickViewBtn.dataset.selectedVariant = variantId; }
  });

  // Direct add-to-cart from product cards
  document.addEventListener('submit', async function(e) {
    const form = e.target.closest('.fj-card__add-to-cart-form');
    if (!form) return;
    e.preventDefault();
    const button = form.querySelector('.fj-quick-add-btn');
    if (!button) return;
    const originalHTML = button.innerHTML;
    button.disabled = true;
    button.innerHTML = '<span class="fj-spinner"></span> Legger til...';
    try {
      const formData = new FormData(form);
      const response = await fetch('/cart/add.js', { method: 'POST', body: formData });
      const data = await response.json();
      if (!response.ok) {
        /* Rettet 14.08.2026: svarkroppen ble tidligere kastet, og kunden fikk
           alltid «Feil - prøv igjen» uansett årsak. Shopify oppgir grunnen i
           `description` (utsolgt, antallsgrense, ugyldig variant) — den vises
           nå, slik at kunden vet om det nytter å prøve på nytt. */
        throw new Error(data && data.description ? data.description : 'Kunne ikke legge i kurven');
      }
      button.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 6L9 17l-5-5"/></svg> Lagt til!';
      updateCartCount();
      openCartDrawer();
      setTimeout(() => { button.disabled = false; button.innerHTML = originalHTML; }, 2000);
    } catch (error) {
      console.error('Add to cart failed:', error);
      const melding = (error && error.message) ? error.message : 'Feil - prøv igjen';
      button.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6L6 18M6 6l12 12"/></svg> ' + melding;
      setTimeout(() => { button.disabled = false; button.innerHTML = originalHTML; }, 4000);
    }
  });

  async function updateCartCount() {
    try {
      /* Rettet 14.08.2026 — handlekurv-ikonet forsvant.
         Den gamle linjen var:
           document.querySelectorAll('.cart-count-bubble span, #cart-icon-bubble span')
             .forEach(el => { el.textContent = cart.item_count; });
         '#cart-icon-bubble span' er en etterkommer-selektor. I
         sections/header.liquid ligger <span class="svg-wrapper"> (som
         inneholder SELVE handlekurv-ikonet) og <span class="visually-hidden">
         Handlekurv</span> som direkte barn. textContent-tilordningen slettet
         derfor SVG-en: ikonet ble byttet ut med et bart tall, og skjermlesere
         leste «2» i stedet for «Handlekurv». Det kom først tilbake ved
         sideomlasting.
         Her hentes hele ikonet på nytt fra serveren i stedet. Det løser også
         at antallsboblen ikke FANTES når kurven var tom ved sidelasting — den
         rendres bare inne i {% if cart != empty %}. */
      const bubble = document.getElementById('cart-icon-bubble');
      if (bubble) {
        const seksjon = await fetch(window.location.pathname + '?section_id=cart-icon-bubble');
        if (seksjon.ok) {
          const dok = new DOMParser().parseFromString(await seksjon.text(), 'text/html');
          const fersk = dok.getElementById('shopify-section-cart-icon-bubble');
          if (fersk) { bubble.innerHTML = fersk.innerHTML; }
        }
      }

      const response = await fetch('/cart.js');
      if (!response.ok) return;
      const cart = await response.json();
      const bottomNavCount = document.querySelector('.fj-cart-count');
      if (bottomNavCount) { bottomNavCount.textContent = cart.item_count; if (cart.item_count > 0) { bottomNavCount.style.display = 'flex'; } }
    } catch (error) { console.error('Failed to update cart count:', error); }
  }

  function openCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.open === 'function') { cartDrawer.open(); return true; }
    const cartDetails = document.querySelector('#cart-drawer');
    if (cartDetails) { const summary = cartDetails.querySelector('summary'); if (summary) { summary.click(); return true; } }
    const cartNotification = document.querySelector('cart-notification');
    if (cartNotification && typeof cartNotification.open === 'function') { cartNotification.open(); return true; }
    document.dispatchEvent(new CustomEvent('fj:cart-item-added'));
    return false;
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.fj-card__desc-btn');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    const expanded = btn.getAttribute('aria-expanded') === 'true';
    const desc = btn.nextElementSibling;
    if (desc) { btn.setAttribute('aria-expanded', !expanded); desc.hidden = expanded; }
  });

})();

/* ---- Ærlig lagerstatus + spec-chips + pen pris i Quick View (leser ekte data fra kortet brukeren klikket) ---- */
(function(){
  'use strict';
  var qd = null;

  document.addEventListener('click', function(e){
    var t = e.target.closest('.fj-quick-view-trigger');
    if(!t) return;
    var card = t.closest('.fj-card, [data-qv-state]');
    qd = card ? {
      state: card.getAttribute('data-qv-state') || '',
      variants: card.getAttribute('data-qv-variants') || '',
      chips: card.getAttribute('data-qv-chips') || '',
      remote: card.getAttribute('data-qv-remote') || '', // leverandørsynk: «På leverandørlager · sendes innen 2 virkedager»
      sup: '4-28'
    } : null;
  }, true);

  function styleOnce(){
    if(document.getElementById('fj-qv-honest-css')) return;
    var s=document.createElement('style'); s.id='fj-qv-honest-css';
    s.textContent='.fj-qv-chips{display:flex;flex-wrap:wrap;gap:6px;margin:8px 0 6px}.fj-qv-chip{font-size:12px;font-weight:600;background:#eef1ec;color:#1b2d1b;border-radius:999px;padding:3px 11px}.fj-qv-hstock,.fj-qv-hsupplier{padding:11px 14px;border-radius:10px;margin:8px 0;font-size:14px;line-height:1.4}.fj-qv-hstock{background:#eaf3ea;color:#1b2d1b}.fj-qv-hsupplier{background:#fff4e6;color:#7a4a10}.fj-qv-hstock--out{background:#f3eaea;color:#7a1b1b}';
    document.head.appendChild(s);
  }
  function fmtThousands(txt){
    return (txt||'').replace(/(\d+),(\d{2})/, function(m,intp,dec){ return intp.replace(/\B(?=(\d{3})+(?!\d))/g,'.')+','+dec; });
  }
  function parseMap(str){ var m={}; (str||'').split(',').forEach(function(p){ var i=p.indexOf(':'); if(i>0) m[p.slice(0,i).trim()]=p.slice(i+1).trim(); }); return m; }
  function esc(t){ return String(t).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  function stockHTML(state, sup){
    if(state==='remote' && qd && qd.remote){
      var del=qd.remote.split(' · ');
      return '<div class="fj-qv-hsupplier"><strong>'+esc(del[0])+'</strong>'+(del[1]?' – '+esc(del.slice(1).join(' · ')):'')+'</div>';
    }
    if(state==='in') return '<div class="fj-qv-hstock"><strong>På lager i butikk (Tau)</strong> – klar for henting · sendes 1–3 dager</div>';
    if(state==='remote') return '<div class="fj-qv-hsupplier"><strong>Fjernlager</strong> – sendes normalt innen '+sup+' virkedager</div>';
    if(state==='out') return '<div class="fj-qv-hstock fj-qv-hstock--out"><strong>Utsolgt</strong></div>';
    return '<div class="fj-qv-hsupplier">Se lagerstatus på produktsiden</div>';
  }
  function apply(){
    try{
      var content=document.getElementById('fjQvContent'); if(!content) return;
      styleOnce();
      content.querySelectorAll('.fj-qv-price--current, .fj-qv-price--compare').forEach(function(el){
        if(el.getAttribute('data-fjfmt')) return;
        var nt=fmtThousands(el.textContent);
        if(nt!==el.textContent){ el.textContent=nt; }
        el.setAttribute('data-fjfmt','1');
      });
      var avail=content.querySelector('.fj-qv-availability');
      if(!window.fjQvLager && avail && !avail.getAttribute('data-qv-done')){
        avail.innerHTML = qd ? stockHTML(qd.state, qd.sup) : stockHTML('', '4-28');
        avail.setAttribute('data-qv-done','1');
      }
      if(qd && qd.chips){
        var title=content.querySelector('.fj-qv-title');
        if(title && !content.querySelector('.fj-qv-chips')){
          var wrap=document.createElement('div'); wrap.className='fj-qv-chips';
          qd.chips.split('·').forEach(function(c){ c=c.trim(); if(c){ var sp=document.createElement('span'); sp.className='fj-qv-chip'; sp.textContent=c; wrap.appendChild(sp); } });
          if(wrap.children.length) title.insertAdjacentElement('afterend', wrap);
        }
      }
      if(!window.fjQvLager && qd && qd.variants){
        var map=parseMap(qd.variants);
        content.querySelectorAll('.fj-qv-variant-select').forEach(function(sel){
          if(sel.getAttribute('data-qv-bound')) return;
          sel.setAttribute('data-qv-bound','1');
          sel.addEventListener('change', function(){
            setTimeout(function(){
              var idEl=content.querySelector('.fj-qv-variant-id'); var id=idEl?idEl.value:'';
              var st=map[id]||qd.state;
              var a=content.querySelector('.fj-qv-availability'); if(a) a.innerHTML=stockHTML(st, qd.sup);
              content.querySelectorAll('.fj-qv-price--current, .fj-qv-price--compare').forEach(function(el){ var nt=fmtThousands(el.textContent); if(nt!==el.textContent) el.textContent=nt; });
            }, 40);
          });
        });
      }
    }catch(err){ /* fail silent: popup virker fortsatt */ }
  }
  var target=document.getElementById('fjQvContent');
  if(target){
    var mo=new MutationObserver(function(){ if(document.querySelector('#fjQvContent .fj-qv-availability')) apply(); });
    mo.observe(target, {childList:true, subtree:true});
  }
})();
